export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 90,
    slots: { default: 'opt' },
    visible: !that.disabled,
  },
  {
    title: that.$l('table_label_itemNo') || '代码',
    field: 'itemNo',
    minWidth: 80,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_itemName') || '缺陷名称',
    field: 'itemName',
    minWidth: 450,
    headerAlign: 'center',
    align: 'left',
    slots: { default: 'displayItemName' },
    showHeaderOverflow: true,
  }
]
